import { userDetailsApi } from 'api'

interface Params {
  tenantId: string
}

export const deleteUserPinnedTenantApi = ({ tenantId }: Params) =>
  userDetailsApi.delete(`/users/me/tenants/${tenantId}/pin`)
